import React, { useCallback } from 'react'
import { observer } from 'mobx-react'
import {
  Button,
  Switch,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'

import Protected from 'admin/components/protected'
import Setting from 'admin/components/setting'
import { useStores, useApiRequest } from 'admin/hooks'
import * as srv from 'admin/services'
import SlotForm from './form'

import styles from '../styles'

const useStyles = makeStyles(styles)

const TableSlots = observer(() => {
  const { slotStore, notificationStore } = useStores()
  const classes = useStyles()

  const {
    request: updateSlot,
    isLoading: updateProcessing,
  } = useApiRequest(srv.updateSlot, { blocking: true })

  const handleToggleVisible = useCallback(async (row, isVisible) => {
    if (updateProcessing) return
    const response = await updateSlot({
      id: row.id,
      start: row.start,
      end: row.end,
      capacity: row.capacity,
      isVisible,
    })
    if (!response) return
    notificationStore.setSuccess(isVisible ? 'Slot is now visible' : 'Slot is now hidden')
    slotStore.reload()
  }, [updateProcessing])

  if (slotStore.list.length === 0) return null
  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell className={classes.tableCell}>
            Time Start
          </TableCell>
          <TableCell className={classes.tableCell}>
            Time End
          </TableCell>
          <TableCell className={classes.tableCell}>
            Capacity
          </TableCell>
          <TableCell className={classes.tableCell}>
            Visible
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {slotStore.list?.map((row) => (
          <TableRow
            key={row.id}
            className={row.isVisible === false ? classes.hiddenSlotRow : undefined}
          >
            <TableCell component="th" scope="row">
              {row.start}
            </TableCell>
            <TableCell component="th" scope="row">
              {row.end}
            </TableCell>
            <TableCell component="th" scope="row">
              {row.capacity}
            </TableCell>
            <TableCell>
              <Protected
                level="update"
                category="slot"
                silent
                icon={(
                  <span>
                    {row.isVisible === false ? 'No' : 'Yes'}
                  </span>
                )}
              >
                <Switch
                  checked={row.isVisible !== false}
                  onChange={(event) => handleToggleVisible(row, event.target.checked)}
                  disabled={updateProcessing}
                  inputProps={{ 'aria-label': 'toggle slot visibility' }}
                />
              </Protected>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
})

const SlotSetting = () => {
  const { slotStore } = useStores()

  return (
    <Setting
      title="Slots Setting"
      subtitle={!!slotStore.capacitySlot.length &&
        `Capacity per slot: ${slotStore.capacitySlot[0]}`}
      action={(
        <Protected
          level="update"
          category="slot"
        >
          <Button
            variant="contained"
            color="secondary"
            onClick={() => slotStore.setOpenDialog(true)}
          >
            Edit
          </Button>
          <SlotForm />
        </Protected>
      )}
      table={<TableSlots />}
    />
  )
}

export default observer(SlotSetting)
